import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: string;
  title: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  rating: number;
  chapters: number;
  updatedAt: string;
  status: string;
}

export default function MangaCard({
  id,
  title,
  coverImage,
  category,
  categorySlug,
  rating,
  chapters,
  updatedAt,
  status,
}: MangaCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={coverImage}
          alt={`${title} - 韩国漫画在线阅读`}
          title={`${title} - 韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
            {rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
            status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-900/80 to-transparent p-3">
          <span className="text-xs text-background-100">
            共{chapters}话
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center justify-between mt-1.5">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs text-secondary-600 hover:text-secondary-700 transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            {category}
          </Link>
          <span className="text-xs text-foreground-400">{updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}